



























































import { Component, Vue } from 'vue-property-decorator'
import { QueryCouponOpsOverview } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component
export default class CouponOpsCenter extends Vue {
  private statRange: Date[] | null = null
  private overview: any = null

  mounted() {
    this.load()
  }

  private fenToYuan(fen: number) {
    const n = fen == null ? 0 : Number(fen)
    return (n / 100).toFixed(2)
  }

  private async load() {
    const param: any = {}
    if (this.statRange && this.statRange.length === 2) {
      param.statTimes = DateFormat(this.statRange[0]) + ',' + DateFormat(this.statRange[1])
    }
    this.overview = await QueryCouponOpsOverview(param)
  }

  private resetRange() {
    this.statRange = null
    this.load()
  }
}
